import formatDecimal from "./formatDecimal";

export default function(x) {
  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/exponent.js
// module id = 378
// module chunks = 0